<template>
  <CommonExpansionPanel :currentPanel="0">
    <template v-slot:title-panel>
      Buscar
    </template>
    <v-expansion-panel-content>
      <div>
        <FiltersAreaEmailsSolicitudes
          @getAreaNegocioFilters="actualizarFiltros"
          :loading="loading"
        />
      </div>
      <hr />
      <div>
        <TableAreaNegocioSolicitudes
          :loading="loading"
          :total="total"
          :restartPaginacion="restartPaginacion"
          :solicitudes="solicitudes"
          @seleccionSolicitud="seleccionSolicitud"
          @paginacionModificada="paginacionModificada"
          @restartFlag="restartPaginacion = true"
        ></TableAreaNegocioSolicitudes>
      </div>
    </v-expansion-panel-content>
  </CommonExpansionPanel>
</template>

<script>
import CommonExpansionPanel from "@/components/commonComponents/CommonExpansionPanel.vue";
import { mainAxios } from "@/mainAxios.js";
import FiltersAreaEmailsSolicitudes from "./FiltrosAreaNegocio/FiltersAreaEmailsSolicitudes.vue";
import TableAreaNegocioSolicitudes from "./FiltrosAreaNegocio/TableAreaNegocioSolicitudes.vue";
import { getSolicitudesFiltrosAreaNegocio } from "@/services/solicitudes/Solicitudes.js";
import { getStatusList } from "@/services/solicitudes/Solicitudes"

export default {
  components: {
    CommonExpansionPanel,
    FiltersAreaEmailsSolicitudes,
    TableAreaNegocioSolicitudes
  },

  data() {
    return {
      switch_data: 1,
      solicitudes: [],
      filtros: [],
      loading: false,
      area_negocio: localStorage.getItem("area_negocio_id"),
      total: 0,
      elementosPagina: 10,
      pagina: 1,
      restartPaginacion: false,
      areaNegocioId: null,
    };
  },
  props: {
    contactData: Object,
    correosDataFormat: Object,
    routesContactData: Object,
    isModal: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getSolicitudes(body) {
      const alianzaIdFromUrl = this.$route.params.alianza_id;
      const alianzaIdFromStorage =
        localStorage.alianzaId !== "null" ? localStorage.alianzaId : null;
      const alianzaId = alianzaIdFromUrl || alianzaIdFromStorage || null;

      if (alianzaId) {
        body.alianza_id = alianzaId;
      } else {
        delete body.alianza_id;
      }
      //TODO QUIZA AGREGAR ESTE COMMIT https://github.com/Andxtorres/segurify-web-app/commit/4dc4069eebda13c4fb5ad6751d21e9478ed19908
      const requestConfig = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      //add to the body the id if is Agent
      if (localStorage.getItem("rolNotAdmin") === "AGENT")
      {  body.agente_id = Number(localStorage.getItem("id")); }
      this.loading = true;
      mainAxios
        .post(
          `/v1/solicitud/list/${localStorage.agenteUuid}`,
          body,
          requestConfig
        )
        .then(({ data }) => {
          this.loading = false;
          if (data.length) this.solicitudes = data;
          else this.solicitudes = [];
          this.filtros = body;
        });
    },
    getTodasLasSolicitudes() {
      const requestConfig = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      mainAxios
        .get(`/v1/solicitud/info/status/1`, requestConfig)
        .then(({ data }) => {
          this.todasLasSolicitudes = data;
        });
    },
    seleccionSolicitud(val) {
      this.$emit("seleccionSolicitud", val);
    },
    actualizarFiltros(filters, areaNegocioId) {
      this.filtros = filters;
      this.elementosPagina = 10;
      this.pagina = 1;
      this.restartPaginacion = true;
      this.areaNegocioId = areaNegocioId;
      this.getSolicitudesAreaNegocio();
    },
    async getSolicitudesAreaNegocio() {
      this.loading = true;
      try {
        const response = await getSolicitudesFiltrosAreaNegocio(
          this.filtros,
          this.elementosPagina,
          Number(this.pagina) - 1,
          this.areaNegocioId
        );

        if (!Array.isArray(response.data)) {
          throw new Error("Respuesta inválida del servidor");
        }

        this.total = response.total;
        this.solicitudes = response.data.map((sol) => ({
          ...sol,
          status: this.statusList[sol.statusId],
        }));
      } catch {
        this.solicitudes = [];
        this.total = 0;
        this.$toast.error("Ocurrió un error en el servidor");
      } finally {
        this.loading = false;
      }
    },
    paginacionModificada(paginacion) {
      this.elementosPagina = paginacion.elementosPagina;
      this.pagina = paginacion.pagina;
      this.getSolicitudesAreaNegocio();
    },
     async getStatusList() {
        let response  = await getStatusList();
        this.statusList = response.data.reduce((acc, el)=>{
          if (el.etiquetaCrm) {
            acc[el.status] = el.etiquetaCrm;
           }         
          return acc;
        }, {})
    }
  },
  mounted() {
    if ((String(window.location.pathname).includes("/alianza/perfil/")) || (String(window.location.pathname).includes("/perfil/alianza"))) {
      this.getSolicitudes({});
    }
    this.getStatusList();
  },
};
</script>
